import React, { useEffect, useState } from "react";
import "./gemspurchases.scss";
import { Link } from "react-router-dom";
import Navbar from "../landing/header/Navbar";
import { useParams } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import axios from "axios";
import moment from "moment";
import { Api_Url, Api_Url_Staging } from "../../utils/ApiUrl";
const AllPurchasesPremium = () => {
  const { id } = useParams();
  // console.log("name here is ", name)
  const { account } = useWeb3React();
  const [projectdetail, setProjectDetail] = useState(null);
  const getAllProjectsData = async () => {
    try {
      const premiumConfig = {
        method: "get",
        url: `${Api_Url}/users/premium/buyer-all-purchases?by=${account.toLowerCase()}&limit=30&offset=1&privateSale=${id}`,
      };

      const creditConfig = {
        method: "get",
        url: `${Api_Url}/credit/buyer-all-purchases?by=${account.toLowerCase()}&limit=100&offset=1&privateSale=${id}`,
      };

      const minerConfig = {
        method: "get",
        url: `${Api_Url}/nodeminer/${account.toLowerCase()}/transactions`,
      };

      const [premiumRes, creditRes, minerRes] = await Promise.all([
        axios(premiumConfig),
        axios(creditConfig),
        axios(minerConfig),
      ]);

      const premiumData = premiumRes?.data?.data || {};
      const creditData = creditRes?.data?.data || {};
      const minerData = minerRes?.data?.data || {};

      // Merge premium + credit transactions
      const mergedTransactions = [
        ...(premiumData.buyerAllTransationsOfSpecificProject || []),
        ...(creditData.buyerAllTransationsOfSpecificProject || []),
      ];

      let finalTransactions = [...mergedTransactions];
      let minerTokens = 0;

      if (id === "RAIN") {
        const minerTransactions = (minerData.merge || []).map((m) => ({
          transactionTime: m.time,
          price: null,
          amountInvested: null,
          dopPurchased: m.claimableRain,
          tokenSelected: "RAIN",
          privateSale: "RAIN",
          type: "Miner Reward",
        }));

        finalTransactions = [...finalTransactions, ...minerTransactions];

        // Sum miner claimableRain for total purchased tokens
        minerTokens = (minerData.merge || []).reduce(
          (acc, m) => acc + (m.claimableRain || 0),
          0
        );
      }

      const totalTokens =
        (premiumData.totalTokens || 0) +
        (creditData.totalTokens || 0) +
        minerTokens;

      const totalNftToken =
        (premiumData.totalNftToken || 0) + (creditData.totalNftToken || 0);

      const projectInfo =
        premiumData.projectInfo?.length > 0
          ? premiumData.projectInfo
          : creditData.projectInfo || [];

      const finalData = {
        buyerAllTransationsOfSpecificProject: finalTransactions,
        totalTokens,
        totalNftToken,
        projectInfo,
        minerTokens,
      };

      setProjectDetail(finalData);
    } catch (error) {
      console.error("Error fetching merged purchases:", error);
    }
  };

  useEffect(() => {
    // console.log("in here ")

    if (id && account)
      // console.log("in here ")

      getAllProjectsData();
  }, [id, account]);

  console.log("PROJECT Details ", projectdetail);

  return (
    <>
      <Navbar />
      <section className="all-purchases">
        <div className="custom-container">
          <div className="main-head">
            <Link to="/mypurchases" className="btn-back">
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6.38016 3.95329L2.3335 7.99996L6.38016 12.0466" stroke="#05BADA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.6668 8H2.44678" stroke="#05BADA" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              Back
            </Link>
          </div>
          <div className="main-heading">
            <p>MY PURCHASES</p>
            <div className="twice-elem">
              {projectdetail?.projectInfo[0]?.projectImage ? (
                <img
                  width={24}
                  src={projectdetail?.projectInfo[0]?.projectImage}
                  alt="img"
                  className="img-fluid"
                />
              ) : projectdetail?.projectInfo[0]?.privateSale ? (
                <img
                  width={24}
                  src={`https://media-gems.gems.vip/logos/${projectdetail?.projectInfo[0]?.privateSale?.toLowerCase()}.svg`}
                  alt="img"
                  className="img-fluid"
                />
              ) : (
                <img
                  width={24}
                  src={`https://media-gems.gems.vip/logos/${projectdetail?.buyerAllTransationsOfSpecificProject?.[0]?.privateSale?.toLowerCase()}.svg`}
                  alt="img"
                  className="img-fluid"
                />
              )}

              <h5>
                {projectdetail?.projectInfo[0]?.projectName ||
                  projectdetail?.projectInfo[0]?.privateSale}
              </h5>
            </div>
          </div>
          <div className="claim-box">
            <div className="left-side">
              <div className="inside-left">
             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M13.1295 18.9613C10.2195 20.6414 6.49861 19.6444 4.81856 16.7344C3.13851 13.8245 4.13553 10.1036 7.04546 8.42354C9.95539 6.74349 13.6763 7.74051 15.3564 10.6504C17.0364 13.5604 16.0394 17.2813 13.1295 18.9613Z" stroke="#85A8AE" stroke-width="1.62529"/>
  <path d="M10.3086 5.35899C12.9007 3.22095 16.7353 3.58905 18.8733 6.18117C21.0113 8.77328 20.6432 12.6078 18.0511 14.7459" stroke="#85A8AE" stroke-width="1.62529"/>
  <rect x="10.0503" y="11.0636" width="3.816" height="3.816" transform="rotate(45 10.0503 11.0636)" fill="#85A8AE"/>
</svg>
                <div className="right-text">
                  <p>Tokens Purchased</p>
                  <h5>
                    {projectdetail?.totalTokens || projectdetail?.totalNftToken
                      ? (
                          projectdetail?.totalTokens +
                          projectdetail?.totalNftToken
                        )?.toLocaleString()
                      : "0"}{" "}
                    {projectdetail?.projectInfo[0]?.privateSale}{" "}
                    {/* <span>+0.8%</span> */}
                  </h5>
                </div>
              </div>
              <div className="bottom-inline">
                <p>
                  <span></span> {projectdetail?.totalTokens?.toLocaleString()}{" "}
                  Tokens
                </p>
                <p>
                  <span></span> {projectdetail?.totalNftToken?.toLocaleString()}{" "}
                  NFTs
                </p>
                {/* <p>
                  <span></span> {projectdetail?.minerTokens?.toLocaleString()}{" "}
                  Miner Rewards
                </p> */}
              </div>
            </div>
            <div className="right-side"></div>
          </div>
          <div className="custom-table">
            <div class="table-responsive">
              <table class="table m-0">
                <thead>
                  <tr>
                    <th>Purchased on</th>
                    <th>PURCHASE PRICE</th>
                    <th>Amount Spent</th>
                    <th>Token PURCHASED</th>
                    <th>TYPE</th>
                  </tr>
                </thead>
                <tbody>
                  {projectdetail?.buyerAllTransationsOfSpecificProject?.map(
                    (project, index) => (
                      <tr key={index}>
                        <td>
                          {moment(project?.transactionTime)?.format(
                            "hh:mm DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {project?.price
                            ? `$${project?.price}/
                          ${projectdetail?.projectInfo[0]?.privateSale}`
                            : ""}
                        </td>
                        <td>
                          {project?.amountInvested ? (
                            <>
                              {project?.amountInvested?.toLocaleString()}{" "}
                              {project?.tokenSelected}
                            </>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>
                          {project?.privateSale != "MATCHAIN"
                            ? project?.dopPurchased?.toLocaleString()
                            : project?.totalMatchainPurchased?.toLocaleString()}{" "}
                          {projectdetail?.projectInfo[0]?.privateSale
                            ? projectdetail?.projectInfo[0]?.privateSale
                            : projectdetail
                                ?.buyerAllTransationsOfSpecificProject?.[0]
                                ?.privateSale}
                        </td>
                        <td>{project?.type}</td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AllPurchasesPremium;
